/* 🤖 this file was generated by svg-to-ts */
export const matIconCoffee: {
  name: 'coffee';
  data: string;
} = {
  name: 'coffee',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18.5 3H6c-1.1 0-2 .9-2 2v5.71c0 3.83 2.95 7.18 6.78 7.29 3.96.12 7.22-3.06 7.22-7v-1h.5c1.93 0 3.5-1.57 3.5-3.5S20.43 3 18.5 3zM16 5v3H6V5h10zm0 5v1c0 2.76-2.24 5-5 5s-5-2.24-5-5v-1m12.5-2H18V5h.5c.83 0 1.5.67 1.5 1.5S19.33 8 18.5 8zM4 19h16v2H4v-2z"/></svg>`
};
